module.exports = __webpack_public_path__ + "img/SSD.36c2fc26.svg";